/**
 * GENERATED — do not edit. Run `node scripts/generate-a11y-statement.mjs`.
 *
 * Source: scripts/lib/a11y-scope.mjs (the page list the audit actually scans)
 * and config/a11y-baseline.json (the debt it actually found). Editing this
 * file by hand publishes a claim no test is holding up; the gate rewrites it.
 */

/** The standard the public site is held to. */
export const A11Y_CONFORMANCE_TARGET = "WCAG 2.1 level AA";

/** axe-core rule tags the scan runs — WCAG 2.0 and 2.1, levels A and AA. */
export const A11Y_STANDARD_TAGS: readonly string[] = ["wcag2a","wcag2aa","wcag21a","wcag21aa"];

/** Impacts that fail the build. Serious and critical; not everything. */
export const A11Y_BLOCKING_IMPACTS: readonly string[] = ["serious","critical"];

/** Every page the automated scan visits, at every viewport below. */
export const A11Y_AUDITED_PAGES: ReadonlyArray<{ route: string; label: string }> = [
  { route: "/", label: "the home page" },
  { route: "/pricing", label: "pricing" },
  { route: "/auth", label: "sign-in and sign-up" },
  { route: "/security", label: "security" },
  { route: "/trust", label: "the trust center" },
  { route: "/for-individuals", label: "for individuals" },
  { route: "/for-enterprise", label: "for enterprise" },
  { route: "/legal", label: "the legal index" },
];

/** The two shapes each page is measured at. */
export const A11Y_VIEWPORTS: ReadonlyArray<{ name: string; width: number; height: number }> = [
  { name: "desktop", width: 1440, height: 900 },
  { name: "phone", width: 390, height: 844 },
];

/** What the audit does NOT cover, and why. Published beside what it does. */
export const A11Y_NOT_AUDITED: ReadonlyArray<{ what: string; reason: string }> = [
  { what: "onboarding and checkout", reason: "both send you to the sign-in page when you are signed out, so an automated scan of them measures the sign-in page under another name and reports a clean result that means nothing. Covering them honestly needs a signed-in browser session in the test harness, which we have not built yet." },
  { what: "the signed-in app and the chat", reason: "the same limit. It is the surface our customers spend their working day in, and it is the largest gap on this page." },
  { what: "anything only a person can judge", reason: "automated checks find a well-documented minority of accessibility problems — roughly a third by most measurements. Whether a heading order makes sense, whether alternative text is useful rather than merely present, and whether a screen reader can complete a task are all things a tool reports as clean. We have not commissioned an audit by someone who uses assistive technology, and until we have, the honest word for this page is a floor and not a certificate." },
];

/**
 * Outstanding serious/critical findings, read from the baseline at generation
 * time. Never typed: re-record a violation and this number moves, so the
 * sentence below cannot stay true after the truth changes.
 */
export const A11Y_OUTSTANDING = 0;

/** The standing claim, in the house voice, chosen by the number above. */
export const A11Y_STANDING_STATEMENT = "no serious or critical issue is outstanding on any page we audit, and the build refuses a new one.";

/** Where somebody reports a barrier, and what we commit to. */
export const A11Y_CONTACT_EMAIL = "support@prest0.ai";
export const A11Y_RESPONSE_COMMITMENT = "within five business days";

/**
 * The same facts as bare prose lines, for the public-site index the signed-out
 * Prest0n searches (D13). Not rendered — the page renders the constants above.
 * The section's own sentences interpolate those constants, and the index drops
 * any line carrying braces, so without these a visitor asking whether the site
 * works with a screen reader would find nothing. See the generator.
 */
export const A11Y_LINES: readonly string[] = [
  "prest0 holds its public website to WCAG 2.1 level AA. every build runs an automated accessibility audit before anything ships, and no serious or critical issue is outstanding on any page we audit, and the build refuses a new one.",
  "the pages covered by that automated accessibility audit are the home page, pricing, sign-in and sign-up, security, the trust center, for individuals, for enterprise and the legal index.",
  "each of those pages is measured at 1440 by 900 and 390 by 844, so a problem that only shows up on a phone is still caught.",
  "not yet covered by the automated accessibility audit: onboarding and checkout, the signed-in app and the chat, and anything only a person can judge. we say so on the trust page rather than letting the list of what we do test read as full coverage.",
  "prest0 does not use an accessibility overlay widget and does not intend to. we would rather fix the markup than add a floating button that promises compliance.",
  "why prest0 avoids accessibility overlays: the federal trade commission fined the largest vendor of them a million dollars in january 2025 over the compliance claim they sell, and more than a fifth of the us web accessibility lawsuits filed that year named sites that already had one installed.",
  "if something on prest0 does not work with your screen reader, keyboard, magnifier or voice control, email support@prest0.ai and we will come back to you within five business days. you do not need to name the problem or be a customer.",
];
